(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5744"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5744"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cljH0", function(module, exports) {

$parcel$export(module.exports, "createSVGGrid", () => $8fc6b8bbd146cdca$export$d47c320381fa2abf);
function $8fc6b8bbd146cdca$export$d47c320381fa2abf(container, squaresPerRow, fill, onlyEmbed) {
    if (!container) {
        console.error("Container not found");
        return;
    }
    // Get the container's dimensions
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const responsiveSquares = window.innerWidth <= 991 ? squaresPerRow / 2 : squaresPerRow;
    // Calculate the size of each square
    const squareSize = parseInt(containerWidth / responsiveSquares);
    // Calculate the number of squares per column
    const squaresPerColumn = Math.ceil(containerHeight / squareSize);
    // Create a unique ID for the mask
    const maskId = "mask-" + Math.random().toString(36).substr(2, 9);
    if (!onlyEmbed) {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                    <defs>
                        <mask id="${maskId}">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: responsiveSquares
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                        </mask>
                    </defs>
                </svg>`;
        // Create wrapper for the SVG and mask
        const maskContainer = document.createElement("div");
        maskContainer.className = "mask-container";
        maskContainer.style.maskImage = `url(#${maskId})`;
        // Append SVG to maskContainer
        maskContainer.innerHTML = svgContent;
        container.parentNode.insertBefore(maskContainer, container);
        maskContainer.appendChild(container);
        return maskContainer.querySelector("svg");
    } else {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: squaresPerRow
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                </svg>`;
        container.insertAdjacentHTML("beforeend", svgContent);
        return svgContent;
    }
}

});

parcelRegister("2rxJM", function(module, exports) {

$parcel$export(module.exports, "setLinesWrapper", () => $1c7845f0e1de0887$export$8f060496e19d4bbb);
function $1c7845f0e1de0887$export$8f060496e19d4bbb(lines, callback) {
    // Wrap each line in a .line-wrapper span
    lines.forEach((line)=>{
        const wrapper = document.createElement("span");
        wrapper.classList.add("line-wrapper");
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
    });
    if (typeof callback === "function") callback();
}

});

parcelRegister("kpGgi", function(module, exports) {

$parcel$export(module.exports, "getElementHeightInRem", () => $edc6ecc670d98733$export$d6278f2ff6cc02ee);
/**
 * Converts a length value from any CSS unit to pixels.
 * @param {string} value - The length value as a string (e.g., "2rem", "50px").
 * @returns {number} - The length value in pixels.
 */ function $edc6ecc670d98733$var$convertToPixels(value) {
    // Create a temporary element to use the browser's rendering to convert the value to pixels
    const tempElement = document.createElement("div");
    tempElement.style.position = "absolute";
    tempElement.style.visibility = "hidden";
    tempElement.style.width = value;
    document.body.appendChild(tempElement);
    const pixelValue = parseFloat(window.getComputedStyle(tempElement).width);
    document.body.removeChild(tempElement);
    return pixelValue;
}
function $edc6ecc670d98733$export$d6278f2ff6cc02ee(element) {
    if (!element) throw new Error("Element is required");
    // Get the computed style of the element
    const computedStyle = window.getComputedStyle(element);
    // Get the height of the element in pixels
    const heightInPixels = parseFloat(computedStyle.height);
    // Get the font size of the root element (html) in rem units and convert it to pixels
    const rootFontSizeInRem = window.getComputedStyle(document.documentElement).fontSize;
    const rootFontSizeInPixels = $edc6ecc670d98733$var$convertToPixels(rootFontSizeInRem);
    // Calculate height in rem units
    const heightInRem = heightInPixels / rootFontSizeInPixels;
    return heightInRem;
}

});

function $ce6a18b12420bce7$export$7fd17f34fe72f4b0() {
    const loading = document.querySelector(".loading");
    if (!loading) return;
    const squares = loading.querySelectorAll("svg rect");
    gsap.to(squares, {
        opacity: 0,
        duration: 0.01,
        stagger: {
            from: "random",
            each: 0.01
        },
        ease: "none",
        immediateRender: true,
        onComplete: ()=>{
            loading.style.display = "none";
        }
    });
    // Loading animation
    const links = document.querySelectorAll("a");
    links.forEach((l)=>{
        l.addEventListener("click", (e)=>{
            // e.preventDefault();
            const href = l.href;
            const url = new URL(href);
            if (window.location.origin === url.origin && window.location.pathname !== url.pathname && l.target !== "_blank") {
                e.preventDefault();
                loading.style.display = "flex";
                gsap.to(squares, {
                    opacity: 1,
                    duration: 0.005,
                    stagger: {
                        from: "random",
                        each: 0.005
                    },
                    immediateRender: true
                });
                setTimeout(()=>{
                    window.location.href = href;
                }, 500);
            }
        });
    });
}



var $cljH0 = parcelRequire("cljH0");
// Link timelines to scroll position
function $719658c63b791dcb$var$createScrollTrigger(triggerElement, start, end, delay, withScroll) {
    const squares = triggerElement.querySelectorAll("rect");
    gsap.set(squares, {
        opacity: 0
    });
    const trigger = {
        trigger: triggerElement,
        scrub: true,
        start: start,
        fastScrollEnd: 500,
        preventOverlaps: "scroll-headings"
    };
    if (!withScroll) {
        trigger.onEnter = ()=>{
            gsap.to(squares, {
                opacity: 1,
                delay: delay,
                duration: 0.01,
                overwrite: true,
                stagger: {
                    each: 0.01,
                    from: "random"
                },
                ease: "bounce.out",
                onComplete: ()=>{
                    gsap.set(triggerElement.parentNode, {
                        maskImage: "none"
                    });
                }
            });
        };
        gsap.timeline({
            scrollTrigger: trigger
        });
    } else {
        trigger.end = end;
        gsap.timeline({
            scrollTrigger: trigger
        }).to(squares, {
            opacity: 1,
            duration: 0.01,
            overwrite: true,
            stagger: {
                each: 0.01,
                from: "random"
            },
            ease: "none"
        });
    }
}
function $719658c63b791dcb$export$e727d27e39c4b766() {
    const blocks = document.querySelectorAll("[stagger-heading]");
    blocks.forEach((el)=>{
        const maskEl = (0, $cljH0.createSVGGrid)(el, 10);
        el.classList.add("init");
        const startVal = el.dataset.startPos || "center bottom", endVal = el.dataset.endPos || "bottom center", delay = el.dataset.delay || 0, withScrollTrigger = el.dataset.withScroll || false;
        $719658c63b791dcb$var$createScrollTrigger(maskEl, startVal, endVal, delay, withScrollTrigger);
    });
}



var $2rxJM = parcelRequire("2rxJM");
// Link timelines to scroll position
function $1aa2e0393d0f1beb$var$createScrollTrigger(triggerElement, elements, start, end, stagger, delay, withScroll) {
    const trigger = {
        trigger: triggerElement,
        scrub: true,
        start: start,
        fastScrollEnd: 500,
        preventOverlaps: "scroll-text"
    };
    if (!withScroll) {
        trigger.onEnter = ()=>{
            gsap.to(elements, {
                yPercent: 0,
                stagger: stagger,
                ease: "power4.out",
                delay: Number(delay)
            });
        };
        gsap.timeline({
            scrollTrigger: trigger
        });
    } else {
        trigger.end = end;
        gsap.timeline({
            scrollTrigger: trigger
        }).to(words, {
            yPercent: 0,
            stagger: stagger,
            ease: "none"
        });
    }
}
function $1aa2e0393d0f1beb$export$1601281ad392a6d8() {
    // Split all words on the brand core section
    const textEls = document.querySelectorAll("[stagger-text]");
    textEls.forEach((el)=>{
        if (el.classList.contains("w-richtext")) {
            const staggerTextEls = new SplitType(el.querySelectorAll("p, li, h2, h3"), {
                types: "lines",
                tagName: "span"
            });
            (0, $2rxJM.setLinesWrapper)(staggerTextEls.lines, ()=>{
                gsap.set(staggerTextEls.lines, {
                    yPercent: 100
                });
            });
        } else {
            const staggerTextEls = new SplitType(el, {
                types: "lines",
                tagName: "span"
            });
            (0, $2rxJM.setLinesWrapper)(staggerTextEls.lines, ()=>{
                gsap.set(staggerTextEls.lines, {
                    yPercent: 100
                });
            });
        }
    });
    const textBlocks = document.querySelectorAll("[stagger-text]");
    textBlocks.forEach((el)=>{
        el.classList.add("init");
        const words1 = el.querySelectorAll(".line"), startVal = el.dataset.startPos || "center bottom", endVal = el.dataset.endPos || "bottom center", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0, withScrollTrigger = el.dataset.withScroll || false;
        // let tl = gsap.timeline({ paused: true });
        $1aa2e0393d0f1beb$var$createScrollTrigger(el, words1, startVal, endVal, stagger, delay, withScrollTrigger);
    });
}


function $7650bdc578b78d7e$export$e49bfc3e559db7() {
    const buttons = document.querySelectorAll(".button");
    if (!buttons) return;
    buttons.forEach((button)=>{
        const buttonBg = button.querySelector(".button-bg");
        const buttonLabel = button.querySelector(".button-label-inner");
        const isRounded = button.classList.contains("is-giga");
        let buttonLabelChars;
        if (buttonLabel) buttonLabelChars = new SplitType(buttonLabel, {
            types: "chars",
            tagName: "span"
        });
        if (buttonBg) {
            if (isRounded) gsap.set(buttonBg, {
                scale: 0
            });
            else gsap.set(buttonBg, {
                yPercent: 100
            });
        }
        button.addEventListener("mouseenter", ()=>{
            if (buttonBg) {
                const animation = {
                    duration: 0.3,
                    ease: "expo.out"
                };
                if (!isRounded) animation.yPercent = 0;
                else animation.scale = 1;
                gsap.to(buttonBg, animation);
            }
            if (buttonLabel && buttonLabelChars) gsap.to(buttonLabelChars.chars, {
                yPercent: -100,
                stagger: 0.01,
                duration: 0.3,
                ease: "expo.out",
                immediateRender: true
            });
            const circles = button.querySelectorAll("svg circle");
            if (circles) gsap.fromTo(button.querySelectorAll("svg circle"), {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.01,
                stagger: {
                    from: "random",
                    each: 0.1
                }
            });
        });
        button.addEventListener("mouseleave", ()=>{
            if (buttonBg) {
                const animation = {
                    duration: 0.3,
                    ease: "expo.out"
                };
                if (!isRounded) animation.yPercent = 100;
                else animation.scale = 0;
                gsap.to(buttonBg, animation);
            }
            if (buttonLabel && buttonLabelChars) gsap.set(buttonLabelChars.chars, {
                yPercent: 0
            });
        });
    });
}


function $8d7867a2083184cb$export$85958f7fefbafb9() {
    const videos = document.querySelectorAll("video[data-play-onscroll]");
    if (!videos) return;
    videos.forEach((video)=>{
        const start = video.dataset.start || "top bottom";
        const pauseOutside = video.dataset.pauseOutside === "true";
        const rewind = video.dataset.rewind === "true";
        const loop = video.dataset.loop === "true";
        video.pause();
        if (loop) video.loop = true;
        let settings = {
            trigger: video,
            start: start,
            onEnter: ()=>{
                video.play();
            }
        };
        if (pauseOutside) {
            settings.onLeave = ()=>{
                $8d7867a2083184cb$var$pauseOrRewind(video, rewind);
            };
            settings.onLeaveBack = ()=>{
                $8d7867a2083184cb$var$pauseOrRewind(video, rewind);
            };
            settings.onEnterBack = ()=>{
                console.log("play video");
                video.play();
            };
        } else settings.once = true;
        ScrollTrigger.create(settings);
    });
}
function $8d7867a2083184cb$var$pauseOrRewind(video, rewind) {
    video.pause();
    if (rewind) video.currentTime = 0;
}
// Function to check if the browser is Safari
function $8d7867a2083184cb$var$isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function $8d7867a2083184cb$export$8e058f710976483f() {
    const videos = document.querySelectorAll("video.transparent-video");
    if (!videos) return;
    videos.forEach((video)=>{
        const webM = video.querySelector('source[type="video/webm"]');
        const mp4 = video.querySelector('source[type="video/mp4"]');
        let formatFound;
        if ($8d7867a2083184cb$var$isSafari()) {
            if (webM) webM.remove();
            mp4.src = mp4.dataset.src;
            formatFound = true;
        } else {
            if (mp4) mp4.remove();
            webM.src = webM.dataset.src;
            formatFound = true;
        }
        if (formatFound) video.load();
    });
}



var $kpGgi = parcelRequire("kpGgi");
function $7ec1dfd28ff53463$export$50e34a31bc7d170d() {
    let mm = gsap.matchMedia();
    // add a media query. When it matches, the associated function will run
    mm.add("(min-width: 768px)", ()=>{
        const nav = document.querySelector(".header .nav"), dropdowns = nav.querySelectorAll(".nav-dropdown-trigger-wrapper"), dropdownEl = nav.querySelector(".nav-dropdown-el.desktop"), dropdownInner = dropdownEl.querySelector(".nav-dropdown-el-inner");
        gsap.set(dropdownInner.querySelectorAll("[data-menu]"), {
            display: "none"
        });
        gsap.set(dropdownInner, {
            height: "0rem"
        });
        let isHover = false;
        let currentMenu;
        dropdowns.forEach((dropdown)=>{
            const id = dropdown.dataset.menu;
            const bg = dropdown.querySelector(".button-bg");
            // const iconClosed = dropdown.querySelector(".nav-dropdown-icon.closed");
            const iconOpen = dropdown.querySelector(".nav-dropdown-icon.open");
            if (!id) return;
            const dropdownChars = new SplitType(dropdown.querySelector(".button-label-inner"), {
                types: "chars",
                tagName: "span"
            });
            gsap.set(bg, {
                yPercent: 100
            });
            gsap.set(iconOpen.querySelectorAll("circle"), {
                opacity: 0
            });
            dropdown.addEventListener("mouseenter", (e)=>{
                if (currentMenu === id) return;
                if (currentMenu) {
                    const previousActiveEl = nav.querySelector(`.nav-dropdown-trigger-wrapper[data-menu="${currentMenu}"]`);
                    $7ec1dfd28ff53463$var$setOffState(previousActiveEl);
                }
                isHover = true;
                currentMenu = id;
                $7ec1dfd28ff53463$var$setOnState(dropdown);
                // Logic for dropdown menu
                const activeMenu = dropdownInner.querySelector(`[data-menu="${id}"]`);
                dropdownEl.classList.add("active");
                gsap.set(dropdownInner.querySelectorAll("[data-menu]"), {
                    display: "none"
                });
                gsap.set(activeMenu, {
                    display: "grid"
                });
                const activeHeight = (0, $kpGgi.getElementHeightInRem)(activeMenu);
                gsap.to(dropdownInner, {
                    height: `${activeHeight}rem`,
                    duration: 0.3,
                    ease: "expo.out"
                });
            });
            nav.addEventListener("mouseleave", (e)=>{
                isHover = false;
                currentMenu = null;
                $7ec1dfd28ff53463$var$setAllOffStates(dropdowns);
                if (!$7ec1dfd28ff53463$var$isMouseOverElement(nav, e)) gsap.to(dropdownInner, {
                    height: `0rem`,
                    duration: 0.3,
                    ease: "expo.out",
                    onComplete: ()=>{
                        gsap.set(dropdownInner.querySelectorAll("[data-menu]"), {
                            display: "none"
                        });
                        dropdownEl.classList.remove("active");
                    }
                });
            });
        // return () => { // optional
        //   // custom cleanup code here (runs when it STOPS matching)
        // };
        });
    });
    mm.add("(max-width: 767px)", ()=>{
        const nav = document.querySelector(".header .nav"), mobileTrigger = document.querySelector(".mobile-trigger"), mobileOverlay = document.querySelector(".submenu-overlay"), dropdowns = nav.querySelectorAll(".nav-dropdown-trigger-wrapper");
        // dropdownEl = nav.querySelector(".nav-dropdown-el.desktop"),
        // dropdownInner = dropdownEl.querySelector(".nav-dropdown-el-inner");
        gsap.set(nav, {
            height: 0
        });
        gsap.set(mobileOverlay, {
            opacity: 0,
            backdropFilter: "blur(0px)"
        });
        const mobileTriggerTl = gsap.timeline({
            paused: true
        });
        mobileTriggerTl.to(mobileTrigger.querySelectorAll(".circle-menu"), {
            scale: 0,
            duration: 0.2
        }).fromTo(mobileTrigger.querySelectorAll(".circle-close"), {
            scale: 0
        }, {
            scale: 1,
            duration: 0.2
        }, 0);
        mobileTrigger.addEventListener("click", ()=>{
            if (mobileTrigger.classList.contains("active")) {
                mobileTriggerTl.reverse();
                gsap.to(nav, {
                    height: 0,
                    ease: "expo.out"
                });
                $7ec1dfd28ff53463$var$setAllDropdownOffStates(dropdowns);
                gsap.to(mobileOverlay, {
                    opacity: 0,
                    backdropFilter: "blur(0px)",
                    duration: 0.5,
                    ease: "expo.out",
                    onComplete: ()=>{
                        gsap.set(mobileOverlay, {
                            display: "none"
                        });
                    }
                });
            } else {
                mobileTriggerTl.play();
                gsap.to(nav, {
                    height: "auto",
                    ease: "expo.out"
                });
                gsap.set(mobileOverlay, {
                    display: "block"
                });
                gsap.to(mobileOverlay, {
                    opacity: 1,
                    backdropFilter: "blur(24px)",
                    duration: 0.5,
                    ease: "expo.out"
                });
            }
            mobileTrigger.classList.toggle("active");
        });
        let currentMenu;
        dropdowns.forEach((dropdown)=>{
            const id = dropdown.dataset.menu;
            const bg = dropdown.querySelector(".button-bg");
            const dropdownInner = dropdown.querySelector(".nav-dropdown-el.mobile");
            // const iconClosed = dropdown.querySelector(".nav-dropdown-icon.closed");
            const iconOpen = dropdown.querySelector(".nav-dropdown-icon.open");
            if (!id) return;
            const dropdownChars = new SplitType(dropdown.querySelector(".button-label-inner"), {
                types: "chars",
                tagName: "span"
            });
            gsap.set(bg, {
                yPercent: 100
            });
            gsap.set(iconOpen.querySelectorAll("circle"), {
                opacity: 0
            });
            dropdown.addEventListener("click", ()=>{
                if (currentMenu === id) {
                    $7ec1dfd28ff53463$var$setDropdownOffState(dropdown);
                    currentMenu = null;
                } else {
                    if (currentMenu) {
                        const previousActiveEl = nav.querySelector(`.nav-dropdown-trigger-wrapper[data-menu="${currentMenu}"]`);
                        $7ec1dfd28ff53463$var$setDropdownOffState(previousActiveEl);
                    }
                    currentMenu = id;
                    $7ec1dfd28ff53463$var$setDropdownOnState(dropdown);
                }
            });
        });
    });
// // later, if we need to revert all the animations/ScrollTriggers...
// mm.revert();
}
function $7ec1dfd28ff53463$var$isMouseOverElement(element, event) {
    // Check if the mouse is over the specified element or its descendants
    return element.contains(event.relatedTarget);
}
function $7ec1dfd28ff53463$var$setOnState(el) {
    gsap.to(el.querySelectorAll(".char"), {
        yPercent: -100,
        stagger: 0.01,
        duration: 0.3,
        ease: "expo.out",
        immediateRender: true
    });
    gsap.to(el.querySelector(".button-bg"), {
        yPercent: 0,
        duration: 0.3,
        ease: "expo.out"
    });
    gsap.to(el.querySelectorAll(".closed circle"), {
        opacity: 0,
        duration: 0.01,
        stagger: {
            each: 0.1
        }
    });
    gsap.to(el.querySelectorAll(".open circle"), {
        opacity: 1,
        duration: 0.01,
        stagger: {
            each: 0.1
        }
    });
}
function $7ec1dfd28ff53463$var$setOffState(el) {
    gsap.set(el.querySelectorAll(".char"), {
        yPercent: 0
    });
    gsap.to(el.querySelector(".button-bg"), {
        yPercent: 100,
        duration: 0.3,
        ease: "expo.out"
    });
    gsap.to(el.querySelectorAll(".closed circle"), {
        opacity: 1,
        duration: 0.01,
        stagger: {
            each: 0.1
        }
    });
    gsap.to(el.querySelectorAll(".open circle"), {
        opacity: 0,
        duration: 0.01,
        stagger: {
            each: 0.1
        }
    });
}
function $7ec1dfd28ff53463$var$setAllOffStates(dropdowns) {
    dropdowns.forEach((el)=>$7ec1dfd28ff53463$var$setOffState(el));
}
function $7ec1dfd28ff53463$var$setDropdownOffState(dropdown) {
    const dropdownInner = dropdown.querySelector(".nav-dropdown-el.mobile");
    dropdownInner.classList.remove("active");
    gsap.to(dropdownInner, {
        height: "0rem",
        duration: 0.3,
        ease: "expo.out"
    });
    $7ec1dfd28ff53463$var$setOffState(dropdown);
}
function $7ec1dfd28ff53463$var$setAllDropdownOffStates(dropdowns) {
    dropdowns.forEach((el)=>$7ec1dfd28ff53463$var$setDropdownOffState(el));
}
function $7ec1dfd28ff53463$var$setDropdownOnState(dropdown) {
    // Logic for dropdown menu
    const activeMenu = dropdown.querySelector(`[data-menu]`);
    const dropdownInner = dropdown.querySelector(".nav-dropdown-el.mobile");
    dropdownInner.classList.add("active");
    const activeHeight = (0, $kpGgi.getElementHeightInRem)(activeMenu);
    gsap.to(dropdownInner, {
        height: `${activeHeight + 0.25}rem`,
        duration: 0.3,
        ease: "expo.out"
    });
    $7ec1dfd28ff53463$var$setOnState(dropdown);
}


function $d9d8e6151a123ccd$export$fc2ce4586759bfa0() {
    const imageMasks = document.querySelectorAll("[image-mask]");
    if (!imageMasks) return;
    imageMasks.forEach((el)=>{
        const type = el.getAttribute("image-mask");
        if (type === "diamond") $d9d8e6151a123ccd$var$setDiamondMask(el);
        if (type === "hexagon") $d9d8e6151a123ccd$var$setHexagonMask(el);
        if (type === "bubbles") $d9d8e6151a123ccd$var$setBubblesMask(el);
    });
}
function $d9d8e6151a123ccd$var$setDiamondMask(el) {
    const start = el.dataset.startPos || "center bottom";
    gsap.set(el, {
        clipPath: "polygon(100% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 100%, 100% 0%)"
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: el,
            scrub: true,
            start: start,
            once: true,
            onEnter: ()=>{
                gsap.fromTo(el, {
                    clipPath: "polygon(100% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 100%, 100% 0%)"
                }, {
                    clipPath: "polygon(100% 0%, 60% 0%, 0% 60%, 0% 100%, 40% 100%, 100% 40%)",
                    duration: 1,
                    ease: "expo.out"
                });
            }
        }
    });
}
function $d9d8e6151a123ccd$var$setHexagonMask(el) {
    const start = el.dataset.startPos || "center bottom";
    gsap.set(el, {
        clipPath: "polygon(100% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 100%, 100% 0%)"
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: el,
            scrub: true,
            start: start,
            once: true,
            onEnter: ()=>{
                gsap.fromTo(el, {
                    clipPath: "polygon(100% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 100%, 100% 0%)"
                }, {
                    clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
                    duration: 1,
                    ease: "expo.out"
                });
            }
        }
    });
}
function $d9d8e6151a123ccd$var$setBubblesMask(el) {
    const start = el.dataset.startPos || "center bottom";
    const mask = el.querySelector(".svg-mask");
    const maskId = "mask-" + Math.random().toString(36).substr(2, 9);
    console.log(mask, mask.querySelector("mask"));
    mask.querySelector("clipPath").id = maskId;
    el.style.clipPath = `url(#${maskId})`;
    const path = mask.querySelector("path");
    gsap.set(path, {
        d: "M1,0.5 C1,0.557,0.991,0.611,0.973,0.662 C0.966,0.683,0.957,0.704,0.947,0.724 C0.928,0.763,0.903,0.799,0.874,0.831 C0.842,0.868,0.804,0.9,0.761,0.926 C0.727,0.948,0.689,0.965,0.65,0.977 C0.602,0.992,0.552,1,0.5,1 C0.462,1,0.425,0.996,0.389,0.988 C0.376,0.985,0.363,0.981,0.35,0.977 C0.311,0.965,0.273,0.948,0.239,0.926 C0.187,0.895,0.142,0.854,0.105,0.807 C0.072,0.764,0.045,0.715,0.027,0.662 C0.009,0.611,0,0.557,0,0.5 C0,0.46,0.005,0.42,0.014,0.382 C0.018,0.367,0.022,0.352,0.027,0.338 C0.048,0.275,0.082,0.217,0.126,0.169 C0.158,0.132,0.196,0.1,0.239,0.074 C0.255,0.064,0.272,0.055,0.289,0.047 C0.353,0.017,0.425,0,0.5,0 C0.535,0,0.57,0.004,0.603,0.011 C0.68,0.027,0.75,0.06,0.81,0.107 C0.834,0.125,0.855,0.146,0.874,0.169 C0.918,0.217,0.952,0.275,0.973,0.338 C0.985,0.373,0.993,0.41,0.997,0.449 C0.999,0.466,1,0.483,1,0.5"
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: el,
            scrub: true,
            start: start,
            once: true,
            onEnter: ()=>{
                gsap.fromTo(path, {
                    morphSVG: {
                        shape: "M1,0.5 C1,0.557,0.991,0.611,0.973,0.662 C0.966,0.683,0.957,0.704,0.947,0.724 C0.928,0.763,0.903,0.799,0.874,0.831 C0.842,0.868,0.804,0.9,0.761,0.926 C0.727,0.948,0.689,0.965,0.65,0.977 C0.602,0.992,0.552,1,0.5,1 C0.462,1,0.425,0.996,0.389,0.988 C0.376,0.985,0.363,0.981,0.35,0.977 C0.311,0.965,0.273,0.948,0.239,0.926 C0.187,0.895,0.142,0.854,0.105,0.807 C0.072,0.764,0.045,0.715,0.027,0.662 C0.009,0.611,0,0.557,0,0.5 C0,0.46,0.005,0.42,0.014,0.382 C0.018,0.367,0.022,0.352,0.027,0.338 C0.048,0.275,0.082,0.217,0.126,0.169 C0.158,0.132,0.196,0.1,0.239,0.074 C0.255,0.064,0.272,0.055,0.289,0.047 C0.353,0.017,0.425,0,0.5,0 C0.535,0,0.57,0.004,0.603,0.011 C0.68,0.027,0.75,0.06,0.81,0.107 C0.834,0.125,0.855,0.146,0.874,0.169 C0.918,0.217,0.952,0.275,0.973,0.338 C0.985,0.373,0.993,0.41,0.997,0.449 C0.999,0.466,1,0.483,1,0.5",
                        type: "rotational"
                    }
                }, {
                    morphSVG: {
                        shape: "M1,0.212 C1,0.314,0.928,0.399,0.832,0.42 C0.838,0.446,0.842,0.473,0.842,0.501 C0.842,0.533,0.837,0.564,0.829,0.593 C0.841,0.59,0.853,0.588,0.866,0.588 C0.94,0.588,1,0.648,1,0.722 C1,0.796,0.94,0.856,0.866,0.856 C0.801,0.856,0.747,0.811,0.735,0.75 C0.673,0.809,0.59,0.844,0.499,0.844 C0.447,0.844,0.398,0.833,0.354,0.812 C0.354,0.816,0.354,0.819,0.354,0.823 C0.354,0.921,0.275,1,0.177,1 C0.079,1,0,0.921,0,0.823 C0,0.725,0.079,0.646,0.177,0.646 C0.181,0.646,0.185,0.646,0.189,0.646 C0.169,0.602,0.157,0.553,0.157,0.501 C0.157,0.465,0.163,0.43,0.173,0.397 C0.163,0.399,0.154,0.4,0.144,0.4 C0.064,0.4,0,0.336,0,0.256 C0,0.177,0.064,0.113,0.144,0.113 C0.215,0.113,0.274,0.165,0.285,0.233 C0.344,0.185,0.418,0.157,0.499,0.157 C0.527,0.157,0.555,0.16,0.581,0.167 C0.601,0.071,0.686,0,0.788,0 C0.905,0,1,0.095,1,0.212",
                        type: "rotational"
                    },
                    duration: 0.5
                });
            }
        }
    });
}


// Link timelines to scroll position
function $4013e65a83b1b778$var$createScrollList(triggerElement, elements, start, stagger, delay) {
    gsap.set(elements, {
        yPercent: 100,
        opacity: 0
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: start,
            onEnter: ()=>{
                gsap.to(elements, {
                    yPercent: 0,
                    opacity: 1,
                    stagger: stagger,
                    ease: "power4.out",
                    delay: Number(delay)
                });
            }
        }
    });
}
function $4013e65a83b1b778$export$9b05384e3b3cbff1() {
    const list = document.querySelectorAll("[stagger-list]");
    console.log(list);
    if (!list) return;
    list.forEach((el)=>{
        const elements = el.querySelectorAll("[stagger-el]"), startVal = el.dataset.startPos || "top top", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0;
        if (!elements) return;
        $4013e65a83b1b778$var$createScrollList(el, elements, startVal, stagger, delay);
    });
}


function $b140b9eb34f1ac44$export$4bc49541bd3cd0fc() {
    const forms = document.querySelectorAll("form");
    if (!forms) return;
    forms.forEach((form)=>{
        const formSubmitButton = form.querySelector(".button.form-submit");
        const submitButton = form.querySelector(".submit-button");
        const label = form.querySelector(".button-label");
        if (!formSubmitButton || !submitButton) return;
        // add event listener to the form submit button
        formSubmitButton.addEventListener("click", function(e) {
            e.preventDefault(); // prevent the default action
            // check if the form is valid
            if (form.checkValidity()) {
                // if valid, submit the form and change the button text
                submitButton.click();
                label.textContent = submitButton.getAttribute("data-wait");
            } else // if not valid, report validity (this will show the HTML5 validation messages)
            form.reportValidity();
        });
    });
}


function $7d54ea0d6e840462$export$d5bd5b80f649d6c() {
    const formWrapper = document.querySelector(".contact-form_wrapper"), formTrigger = document.querySelectorAll("[data-contact-open]");
    if (!formWrapper || !formTrigger) return;
    const form = formWrapper.querySelector(".contact-form_inner"), formClose = formWrapper.querySelector(".contact-form_close"), formCloseCircles = formClose.querySelectorAll("circle"), backdrop = formWrapper.querySelector(".contact-form_backdrop");
    // gsap.set(formWrapper, { display: "none" });
    gsap.set(form, {
        width: 0
    });
    gsap.set(backdrop, {
        opacity: 0,
        backdropFilter: "blur(0px)"
    });
    gsap.set(formClose, {
        visibility: "hidden"
    });
    gsap.set(formCloseCircles, {
        opacity: 0
    });
    let isFormActive = false;
    const tl = gsap.timeline({
        paused: true
    });
    tl.set(formWrapper, {
        display: "flex"
    }).to(backdrop, {
        display: "block",
        opacity: 1,
        backdropFilter: "blur(24px)",
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).to(form, {
        width: "auto",
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).set(formClose, {
        visibility: "visible"
    }).to(formCloseCircles, {
        opacity: 1,
        duration: 0.01,
        stagger: {
            each: 0.05,
            from: "random"
        },
        ease: "expo.inOut"
    }, 0.5);
    formTrigger.forEach((trigger)=>{
        trigger.addEventListener("click", ()=>{
            tl.play();
        });
    });
    formClose.addEventListener("click", ()=>{
        tl.reverse();
    });
    formClose.addEventListener("mouseover", ()=>{
        gsap.fromTo(formCloseCircles, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.01,
            stagger: {
                each: 0.05,
                from: "random"
            },
            ease: "none"
        });
    });
}


function $0cd6a27b99afe986$export$568421ea5e873446() {
    const items = document.querySelectorAll(".video-player-full");
    if (!items) return;
    items.forEach((item)=>{
        const trigger = item.querySelector(".video-player-full_trigger"), modal = item.querySelector(".video-player-full_modal");
        if (!trigger || !modal) return;
        const close = modal.querySelector(".video-player-full_modal-close");
        const tl = $0cd6a27b99afe986$var$setVideoModal(modal);
        let player;
        if (typeof Vimeo !== "undefined") {
            player = new Vimeo.Player(modal.querySelector("iframe"));
            tl.eventCallback("onComplete", ()=>{
                player.play();
            });
            tl.eventCallback("onReverseComplete", ()=>{
                player.setCurrentTime(0);
            });
        }
        trigger.addEventListener("click", ()=>{
            $0cd6a27b99afe986$var$openModal(tl);
        });
        close.addEventListener("click", ()=>{
            if (player) player.pause();
            $0cd6a27b99afe986$var$closeModal(tl);
        });
        const modalCloseCircles = close.querySelectorAll("svg circle");
        close.addEventListener("mouseenter", ()=>{
            gsap.fromTo(modalCloseCircles, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.01,
                stagger: {
                    from: "random",
                    each: 0.05
                },
                ease: "none"
            });
        });
    });
}
function $0cd6a27b99afe986$var$setVideoModal(modal) {
    const videoPlayer = modal.querySelector(".video-player-full_video");
    const videoClose = modal.querySelector(".video-player-full_modal-close");
    const backdrop = modal.querySelector(".video-player-full_modal-backdrop");
    gsap.set(modal, {
        visibility: "hidden",
        backdropFilter: "blur(0px)"
    });
    gsap.set(videoClose, {
        scale: 0
    });
    gsap.set(videoPlayer, {
        clipPath: "inset(50%)"
    });
    const tl = gsap.timeline({
        paused: true
    });
    tl.set(backdrop, {
        display: "block"
    }).to(modal, {
        visibility: "visible",
        backdropFilter: "blur(24px)",
        duration: 0.5
    }, 0).to(backdrop, {
        opacity: 0.8,
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).to(videoPlayer, {
        clipPath: "inset(0%)",
        duration: 1,
        ease: "expo.inOut"
    }, 0.2).to(videoClose, {
        scale: 1,
        duration: 0.5,
        ease: "expo.inOut"
    }, 0.4);
    return tl;
}
async function $0cd6a27b99afe986$var$openModal(tl) {
    tl.play();
}
function $0cd6a27b99afe986$var$closeModal(tl) {
    tl.reverse();
}



var $kpGgi = parcelRequire("kpGgi");
function $45ba4da72c4793f2$var$getStoreItems() {
    const purchaseStore = localStorage.getItem("helix_protein_purchase_list");
    if (purchaseStore) return JSON.parse(purchaseStore);
    else {
        $45ba4da72c4793f2$var$setStoreItems([]);
        return [];
    }
}
function $45ba4da72c4793f2$var$setStoreItems(list) {
    localStorage.setItem("helix_protein_purchase_list", JSON.stringify(list));
}
function $45ba4da72c4793f2$var$initPurchaseForm(store) {
    const formTrigger = document.querySelector(".purchase-form_trigger"), formTriggerHeight = (0, $kpGgi.getElementHeightInRem)(formTrigger), formClose = document.querySelector(".purchase-form_close"), formCloseCircles = formClose.querySelectorAll("circle"), form = document.querySelector(".purchase-form"), formInner = document.querySelector(".purchase-form_inner"), backdrop = document.querySelector(".purchase-form_backdrop");
    gsap.set(form, {
        visibility: "hidden",
        opacity: 0
    });
    gsap.set(formInner, {
        height: `${formTriggerHeight}rem`
    });
    gsap.set(backdrop, {
        opacity: 0,
        backdropFilter: "blur(0px)"
    });
    gsap.set(formClose, {
        visibility: "hidden"
    });
    gsap.set(formCloseCircles, {
        opacity: 0
    });
    const tl = gsap.timeline({
        paused: true
    });
    tl.set(form, {
        visibility: "visible"
    }).to(formTrigger, {
        opacity: 0,
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).to(backdrop, {
        display: "block",
        opacity: 1,
        backdropFilter: "blur(24px)",
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).to(formInner, {
        height: "auto",
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).to(form, {
        opacity: 1,
        duration: 0.5,
        ease: "expo.inOut"
    }, 0).set(formClose, {
        visibility: "visible"
    }).to(formCloseCircles, {
        opacity: 1,
        duration: 0.01,
        stagger: {
            each: 0.05,
            from: "random"
        },
        ease: "expo.inOut"
    }, 0.5).set(formTrigger, {
        visibility: "hidden"
    });
    formTrigger.addEventListener("click", ()=>{
        tl.play();
        store.isOpen = true;
    });
    formClose.addEventListener("click", ()=>{
        tl.reverse();
        store.isOpen = false;
    });
    formClose.addEventListener("mouseover", ()=>{
        gsap.fromTo(formCloseCircles, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.01,
            stagger: {
                each: 0.05,
                from: "random"
            },
            ease: "none"
        });
    });
}
function $45ba4da72c4793f2$export$aeddf2181ec81729() {
    document.addEventListener("alpine:init", ()=>{
        Alpine.store("purchaseForm", {
            isOpen: false,
            list: [],
            init () {
                const list = $45ba4da72c4793f2$var$getStoreItems();
                this.list = list;
            },
            addItem (name, quantity) {
                const itemIndex = this.list.findIndex((el)=>el.name === name);
                if (itemIndex === -1) this.list.push({
                    name: name,
                    quantity: Number(quantity)
                });
                else this.list[itemIndex].quantity += Number(quantity);
                $45ba4da72c4793f2$var$setStoreItems(this.list);
            },
            removeItem (index) {
                this.list.splice(index, 1);
                $45ba4da72c4793f2$var$setStoreItems(this.list);
            },
            addQuantity (item) {
                const itemIndex = this.list.findIndex((el)=>el.name === item.name);
                if (itemIndex === -1) return;
                this.list[itemIndex].quantity = parseFloat(Number(this.list[itemIndex].quantity) + 0.1).toFixed(1);
                $45ba4da72c4793f2$var$setStoreItems(this.list);
            },
            subtractQuantity (item) {
                const itemIndex = this.list.findIndex((el)=>el.name === item.name);
                if (itemIndex === -1) return;
                if (this.list[itemIndex].quantity > 0) this.list[itemIndex].quantity = parseFloat(Number(this.list[itemIndex].quantity) - 0.1).toFixed(1);
                $45ba4da72c4793f2$var$setStoreItems(this.list);
            },
            purchaseListFormatted () {
                return this.list.map((item)=>`${item.name} (${item.quantity}mg)`).join("; \n");
            },
            totalItems () {
                if (this.list.length === 1) return `${this.list.length} item`;
                else return `${this.list.length} items`;
            }
        });
        $45ba4da72c4793f2$var$initPurchaseForm(Alpine.store("purchaseForm"));
    });
}


window.addEventListener("beforeunload", ()=>{
    // console.log("beforeunload");
    $9e89071ec39ae27f$var$setAll();
});
window.addEventListener("popstate", ()=>{
    // console.log("popstate");
    $9e89071ec39ae27f$var$setAll();
});
document.addEventListener("pageshow", (event)=>{
    // console.log("pageshow", event);
    // Check if the page was restored from the bfcache
    if (event.persisted) // Re-run your loading animation
    $9e89071ec39ae27f$var$setAll();
});
// wait until DOM is ready (html and svg markup)
document.addEventListener("DOMContentLoaded", function() {
    // console.log("DOMContentLoaded");
    $9e89071ec39ae27f$var$setAll();
});
function $9e89071ec39ae27f$var$setAll() {
    (0, $7ec1dfd28ff53463$export$50e34a31bc7d170d)();
    (0, $7650bdc578b78d7e$export$e49bfc3e559db7)();
    (0, $8d7867a2083184cb$export$85958f7fefbafb9)();
    // setTransparentVideo();
    (0, $d9d8e6151a123ccd$export$fc2ce4586759bfa0)();
    (0, $4013e65a83b1b778$export$9b05384e3b3cbff1)();
    (0, $b140b9eb34f1ac44$export$4bc49541bd3cd0fc)();
    (0, $7d54ea0d6e840462$export$d5bd5b80f649d6c)();
    (0, $0cd6a27b99afe986$export$568421ea5e873446)();
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
}
(0, $45ba4da72c4793f2$export$aeddf2181ec81729)();
document.fonts.ready.then(()=>{
    (0, $1aa2e0393d0f1beb$export$1601281ad392a6d8)();
    (0, $719658c63b791dcb$export$e727d27e39c4b766)();
});

})();
//# sourceMappingURL=globals.js.map
